import { render } from "./ClientJobResultCard.vue?vue&type=template&id=26ad46fc&scoped=true"
import script from "./ClientJobResultCard.vue?vue&type=script&lang=js"
export * from "./ClientJobResultCard.vue?vue&type=script&lang=js"

import "./ClientJobResultCard.vue?vue&type=style&index=0&id=26ad46fc&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ad46fc"]])

export default __exports__